import { config } from "../env";
import { Delete, get, patch, post } from "./helpers/http-handler";

export const adminCreateUser = (payload: object) =>
	post(`${process.env.REACT_APP_API_URL?process.env.REACT_APP_API_URL:config.API_URL}/users`, payload);

export const adminGetUsers = (queryRequest:string) => get(`${process.env.REACT_APP_API_URL?process.env.REACT_APP_API_URL:config.API_URL}/users?${queryRequest}`);

export const adminGetSpecificUser = (id: string) =>
	get(`${process.env.REACT_APP_API_URL?process.env.REACT_APP_API_URL:config.API_URL}/users/${id}`);

export const adminUpdateSpecificUser = (id: string, payload: object) =>
	patch(`${process.env.REACT_APP_API_URL?process.env.REACT_APP_API_URL:config.API_URL}/users/${id}`, payload);

export const adminDeleteSpecificUser = (id: string) =>
	Delete(`${process.env.REACT_APP_API_URL?process.env.REACT_APP_API_URL:config.API_URL}/users/${id}`);

	export const adminUpdateBulkUser = ( payload: object) =>
	// patch(`${process.env.REACT_APP_API_URL?process.env.REACT_APP_API_URL:config.API_URL}/users/bulk/active-inactive`, payload);
	patch(`${process.env.REACT_APP_API_URL?process.env.REACT_APP_API_URL:config.API_URL}/users/client/bulk/active-inactive`, payload);

	export const getAllPermissions = () =>
	get(`${process.env.REACT_APP_API_URL?process.env.REACT_APP_API_URL:config.API_URL}/users/permissions/list`);
	
